import _ from 'lodash';
import React, { useEffect } from 'react';
import Suspended from '~/src/components/Suspended';
import colleges from '~/src/images/colleges';
import { getHighSchoolYear, Ot7Player } from '~/src/models/Ot7Player';
import { imgOt7_135x180NeonBgPatternWebp } from '../images';
import { colorFromInt } from '../lib';
import './FeaturedPlayers.scss';
import PhotoVideo from './PhotoVideo';

const Player = ({ player }: { player: Ot7Player }) => {
	const commitedCollegeLogo = colleges[player.committed_college];
	const notableOfferLogos = player.potential_colleges?.filter((c) => colleges[c]).slice(0, 4);

	return (
		<div className="Player">
			<div className={`PictureContainer`}>
				<div
					className={`PictureFrame${player.image_path ? ' Player' : ' Team'}`}
					style={{
						backgroundColor: player.ot7_team.primary_color ? colorFromInt(player.ot7_team.primary_color) : '#fff',
					}}
				>
					{player.image_path && (
						<PhotoVideo
							src={`https://images.overtime.tv/${player.image_path}?width=300`}
							alt={player.full_name}
							mobileWidth={300}
							style={{
								backgroundImage: `url(${imgOt7_135x180NeonBgPatternWebp})`,
								backgroundPosition: 'center',
								backgroundSize: 'cover',
							}}
						/>
					)}

					{!player.image_path && player.ot7_team?.logo_path && (
						<PhotoVideo
							src={`https://images.overtime.tv/${player.ot7_team?.logo_path}?width=300`}
							alt={player.full_name}
							mobileWidth={300}
							style={{
								aspectRatio: '1',
							}}
						/>
					)}
				</div>
			</div>

			<div className="InfoContainer">
				<div className="Name">{player.full_name}</div>
				<a className="Team inherit" href={`/teams/${player.ot7_team_id}`}>
					{player.ot7_team?.name}
				</a>
				<div className="Position">
					{player.position}
					{player.graduation_year ? `, ${getHighSchoolYear(player.graduation_year)}` : ''}
				</div>

				<div className="OffersContainer">
					{commitedCollegeLogo && (
						<>
							<div>Committed</div>
							<div className="Offers">
								<div className="Logo">
									<img alt={player.committed_college} src={commitedCollegeLogo} />
								</div>
							</div>
						</>
					)}

					{!commitedCollegeLogo && notableOfferLogos.length > 0 && (
						<>
							<div>Notable Offers</div>
							<div className="Offers">
								{notableOfferLogos.map((college) => (
									<div className="Logo" key={`offer-${player.id}-${college}`}>
										<img alt={college} key={college} src={colleges[college]} />
									</div>
								))}
							</div>
						</>
					)}
				</div>
			</div>
		</div>
	);
};

const _FeaturedPlayers = ({
	title,
	players,
	maxPlayers,
}: {
	title: string;
	players: Ot7Player[];
	maxPlayers: number;
}) => {
	const [featuredPlayers, setFeaturedPlayers] = React.useState<Ot7Player[]>([]);
	useEffect(() => {
		setFeaturedPlayers(_.shuffle(players.filter((p) => p.is_featured)));
	}, [players]);

	if (!featuredPlayers || featuredPlayers.length === 0) {
		return null;
	}

	return (
		<div className="FeaturedPlayers">
			<h2>{title}</h2>
			<div className={`Players${maxPlayers % 3 == 0 ? ' Col-3' : ' Col-2'}`}>
				{featuredPlayers.slice(0, maxPlayers).map((p) => (
					<Player player={p} key={`featured-${p.id}`} />
				))}
			</div>
		</div>
	);
};

const FeaturedPlayers = ({
	title,
	players,
	maxPlayers = 100,
}: {
	title: string;
	players: Ot7Player[];
	maxPlayers?: number;
}) => {
	return (
		<Suspended>
			<_FeaturedPlayers title={title} players={players} maxPlayers={maxPlayers} />
		</Suspended>
	);
};

export default FeaturedPlayers;
